import { createFileRoute } from '@tanstack/react-router';

import { BlockedCreativesPage } from '../features/supply/blockedList/BlockedCreativesPage';
import { blockedListRouteSearchSchema } from '../features/supply/blockedList/blockedListRouteSearch';

export const Route = createFileRoute('/supply/blocked-list/creatives')({
  validateSearch: blockedListRouteSearchSchema,
  component: BlockedCreativesPage,
});
